import { TbaUncontrolledTransactions as Component } from './components/TbaUncontrolledTransactions';
import Connector from './connector';

export const TbaUncontrolledTransactions = () => {
  return <Connector component={Component} />;
};
